module.exports = __webpack_public_path__ + "static/media/Karan Acoustics Mono A amplifier.7f1bb6a2.png";